import { _ as __assign } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { b as useGroupChannelContext, u as useGroupChannel } from '../../chunks/bundle-BykuFiQC.js';
import { G as GroupChannelUIView } from '../../chunks/bundle-CNNoNLn1.js';
import { GroupChannelHeader } from './GroupChannelHeader.js';
import { MessageList } from './MessageList.js';
import { MessageInputWrapper } from './MessageInputWrapper.js';
import { d as deleteNullish } from '../../chunks/bundle-idC_wVZi.js';
import '@sendbird/chat/message';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-BSLHBsOu.js';
import '../../chunks/bundle-44j0QAmj.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-CHW7NXXK.js';
import '../../chunks/bundle--h0f5LUC.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../chunks/bundle-CxpAk_cb.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import './TypingIndicator.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-qcluyCmu.js';
import '../../ui/ConnectionStatus.js';
import '../../ui/Icon.js';
import '../../ui/PlaceHolder.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-DsmBtJ5T.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../chunks/bundle-Bse9fZMw.js';
import '../../chunks/bundle-B8a1gm3B.js';
import '../../chunks/bundle-EMEHizdG.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../ui/Header.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CyIWMcD_.js';
import '../../ui/IconButton.js';
import './Message.js';
import '../../chunks/bundle-DNqRGkzO.js';
import '../../chunks/bundle-DNwRc4lK.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-dyq0aH11.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DRAooF75.js';
import 'dompurify';
import '../../chunks/bundle-CGAxlcUv.js';
import '../../chunks/bundle-xdZcjYxt.js';
import '../../chunks/bundle-DEv-umdP.js';
import '../../chunks/bundle-CSKhnQl7.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-DHLFKbb3.js';
import '../../chunks/bundle-C7OVXMkh.js';
import '../../chunks/bundle-D82dEh7Z.js';
import '../../chunks/bundle-BMOZh9fu.js';
import '../../chunks/bundle-BB95aNhx.js';
import 'react-dom';
import '../../ui/SortByRow.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-CsFWohR-.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-7yeG72vW.js';
import '../../ui/MobileMenu.js';
import '../../ui/ThreadReplies.js';
import '../../chunks/bundle-CBOkD3as.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-CclIyWE2.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../chunks/bundle-DWKpPzuv.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-DTF9UGbO.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-0nLnxiJ2.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-CNGGcC9m.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../chunks/bundle-Bj2tVPd1.js';
import './SuggestedReplies.js';
import '../../chunks/bundle-B5EHFFGW.js';
import './FileViewer.js';
import '../../chunks/bundle-BUqKgNmF.js';
import './RemoveMessageModal.js';
import '../../chunks/bundle-gFEGYRmO.js';
import '../../chunks/bundle-B19WxiWc.js';
import './UnreadCount.js';
import './FrozenNotification.js';
import '../../ui/TypingIndicatorBubble.js';
import '../../Channel/utils/getMessagePartsInfo.js';
import '../../Channel/utils/compareMessagesForGrouping.js';
import '../../chunks/bundle-Jo2fwos6.js';
import '../../chunks/bundle-B1Tn6-pu.js';
import './SuggestedMentionList.js';
import '../../ui/QuoteMessageInput.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-pTFXff0f.js';
import '../../chunks/bundle-X0vBfD3T.js';

var GroupChannelUI = function (props) {
    var context = useGroupChannelContext();
    var _a = useGroupChannel().state, channelUrl = _a.channelUrl, fetchChannelError = _a.fetchChannelError;
    // Inject components to presentation layer
    var _b = deleteNullish(props), _c = _b.renderChannelHeader, renderChannelHeader = _c === void 0 ? function (props) { return React__default.createElement(GroupChannelHeader, __assign({}, props)); } : _c, _d = _b.renderMessageList, renderMessageList = _d === void 0 ? function (props) { return React__default.createElement(MessageList, __assign({}, props, { className: "sendbird-conversation__message-list" })); } : _d, _e = _b.renderMessageInput, renderMessageInput = _e === void 0 ? function () { return React__default.createElement(MessageInputWrapper, __assign({}, props)); } : _e;
    return (React__default.createElement(GroupChannelUIView, __assign({}, props, context, { isInvalid: fetchChannelError !== null, channelUrl: channelUrl, renderChannelHeader: renderChannelHeader, renderMessageList: renderMessageList, renderMessageInput: renderMessageInput })));
};

export { GroupChannelUI, GroupChannelUI as default };
//# sourceMappingURL=GroupChannelUI.js.map
